export default function usePending() {
	const counter = ref(0);

	const pending = computed(() => counter.value > 0);

	async function handler(fn: () => Promise<any>) {
		try {
			counter.value++;
			return await fn();
		} finally {
			counter.value--;
		}
	}

	return {pending, handler};
}
